import { ORDER_JOURNEY_FILTER } from "@convex/constants/orderJourney.lib";

export const ACTION_JOURNEYS_ARGS = {
  filter: ORDER_JOURNEY_FILTER.NEEDS_ACTION,
  limit: 10,
};
